if (!customElements.get('site-accordion')) {
  customElements.define(
    'site-accordion',
    class Accordion extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('.accordion__title');

        this.button?.addEventListener('click', this.handleClick.bind(this));
      }

      handleClick() {
        if (this.isOpen) return;

        this.handleOpen();
      }

      handleOpen() {
        this.groupName && this.closeOtherAccordions();
      }

      /**
       * @param {HTMLElement} accordion
       */
      handleClose(accordion) {
        accordion.removeAttribute('open');
      }

      closeOtherAccordions() {
        this.groupAccordions.forEach((accordion) => {
          if (accordion !== this) {
            this.handleClose(accordion);
          }
        });
      }

      get details() {
        return this.querySelector('details');
      }

      get isOpen() {
        return this.details?.hasAttribute('open');
      }

      get groupName() {
        return this.dataset.group ? this.dataset.group : false;
      }

      /**
       * @type {NodeListOf<HTMLElement>}
       */
      get groupAccordions() {
        return document.querySelectorAll(`.accordion[data-group="${this.groupName}"] details`);
      }
    },
  );
}
